<div class="overlay open-message">

    <div class="overlay-header">
        <h6 class="hide1">{{ messageData?.channel === 'Email' ? 'Email' : 'Text' }} Details</h6>
        <div class="close-btn">
            <button mat-icon-button mat-dialog-close>
                <f-icon [iconConfig]="iconConfig"></f-icon>
            </button>
        </div>
    </div>
    <div class="section-divider"></div>

    <div class="msg-body form " *ngIf="messageData?.channel === 'Email'">

        <div class="row flex ">
            <div class="col-md-8">
                <span class="form-label">To</span>
                <span class="form-value">{{messageData?.messageDetails?.destinationAddress}}</span>
            </div>
            <div class="col-md-4">
                <span class="form-label">Date</span>
                <span class="form-value">{{getDate(messageData?.messageDetails?.sentDate)}}</span>
            </div>
        </div>
        <div class="row flex ">
            <div class="col-md-8">
                <span class="form-label">From</span>
                <span class="form-value">{{messageData?.messageDetails?.fromAddress}}</span>
            </div>
            <div class="col-md-4">
                <span class="form-label">Subject</span>
                <span class="form-value">{{messageData?.messageDetails?.msgSubject}}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <span class="form-label"> Details </span>

                <div class="row" *ngIf="isAPIError">
                    <div class="col-md-12">
                        <f-alert variant="error">There was a problem loading the data. <a href="javascript:void('0')"
                                (click)="openMessageDetail()">
                                Try again</a></f-alert>
                    </div>
                </div>

                <div class="msg-detail hide1">
                    <div [innerHTML]="messageAPIData"></div>

                </div>
            </div>
        </div>




    </div>

    <div class="msg-body form hide1" *ngIf="messageData?.channel === 'Text'">

        <div class="row flex">
            <div class="col-md-8">
                <span class="form-label">To</span>
                <span class="form-value">[Number not available]</span>
            </div>
            <div class="col-md-4">
                <span class="form-label">Date</span>
                <span class="form-value">{{getDate(messageData?.messageDetails?.sentDate)}}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <span class="form-label"> Details </span>
                 <div class="msg-detail1">

                    <div class="row" *ngIf="isAPIError">
                        <div class="col-md-12">
                            <f-alert variant="error">There was a problem loading the data. <a
                                    href="javascript:void('0')" (click)="openMessageDetail()">
                                    Try again</a></f-alert>
                        </div>
                    </div>
                    <p [innerHTML]="messageAPIData"></p>
                </div>
            </div>
        </div>
    </div>
</div>
<app-card-loader class="hide1" *ngIf="showLoader" [loaderMsg]="showLoader" [loaderType]="loaderType"></app-card-loader>